<template>
  <div class="shop-view">
    
    <div class="top" >
      <el-carousel trigger="click" height="540px" class="top_carousel">
        <el-carousel-item v-for="item in base.shop_banner" :key="item">
          <img :src="item" class="top_img" style="width: 100%; height: 100%; object-fit: cover;">
        </el-carousel-item>
      </el-carousel>
      <div class="cate-wrap">

        <Category></Category>
        
      </div>
    </div>

    <div class="navs">
      <div
        v-for="(item,index) in navas"
        :key="index"
        :class="navasIndex==index?'div_activity':'div_noma'"
        @click="navasClick(index)"
      >{{item}}</div>
    </div>

    <!-- <div class="banner22s">
      <span class="banner22s_span">学习从未停止</span>
      <div class="carousel-container">
        <el-carousel height="280px">
          <el-carousel-item v-for="item in slideList" :key="item">
            <img :src="item.image">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div> -->

    <div class="banner22s">
      <span class="banner22s_span">热销产品推荐</span>
      <div class="carousel-container">
        <!-- 图片列表 -->
        <div class="carousel-track">
          <!-- 循环渲染双倍图片实现无缝衔接 -->
          <div v-for="(item, index) in hotProductList" :key="item.id" class="carousel-item3" @click="goProduct(item,1)">
            <img :src="item.thumb"  class="carousel-item2_img2">
            <div class="goods-title">
              <span class="goods-title-text">{{item.title}}</span>
            </div>
          </div>
        </div>
        <el-empty v-if="hotProductList.length==0" description="暂无数据"></el-empty>
      </div>
    </div>

    <!-- <div class="banner22s">
      <span class="banner22s_span">意向采购</span>
      <div class="carousel-container">
        <div class="carousel-track">
          <div
            v-for="(item, index) in imageList2"
            :key="index"
            class="carousel-item2"
            @mouseover="mouseoverClick(index)"
            @click="$router.push(item.link)"
          >
            <img :src="currentIndex==index?item.imgbg1:item.imgbg2" class="carousel-item2_img">
            <div class="ccs_inner_data">
              <img :src="currentIndex==index?item.img1:item.img2">
              <span :class="currentIndex==index?'text1':'text2'">{{item.title}}</span>
              <span class="text3" v-if="currentIndex==index">探索了解</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="point" id="point"></div>
    <div class="banner22s">
      <span class="banner22s_span">积分好礼</span>
      <div class="carousel-container">
        <!-- 图片列表 -->
        <div class="carousel-track">
          <!-- 循环渲染双倍图片实现无缝衔接 -->
          <div v-for="(item, index) in scoreProductList" :key="index" class="carousel-item3" @click="goProduct(item,2)">
            <img :src="item.thumb" class="carousel-item2_img2">
            <div class="goods-title">{{item.title}}</div>
          </div>
        </div>
        <el-empty v-if="scoreProductList.length==0" description="暂无数据"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  },
  data() {
    return {
      imageList2: [
        {
          imgbg1: require("@/assets/icon_cgyx_s.png"),
          imgbg2: require("@/assets/icon_cgyx_n.png"),
          title: "订购流程",
          img1: require("@/assets/icon_cgyx_dls_n.png"),
          img2: require("@/assets/icon_cgyx_dls_s.png"),
          link: "/postdetail/2"
        },
        {
          imgbg1: require("@/assets/icon_cgyx_s.png"),
          imgbg2: require("@/assets/icon_cgyx_n.png"),
          title: "选购产品",
          img1: require("@/assets/icon_cgyx_cpbz_n.png"),
          img2: require("@/assets/icon_cgyx_bpbz_s.png"),
          link: "/postdetail/3"
        },
        {
          imgbg1: require("@/assets/icon_cgyx_s.png"),
          imgbg2: require("@/assets/icon_cgyx_n.png"),
          title: "联系代理商",
          img1: require("@/assets/icon_cgyx_dls_n.png"),
          img2: require("@/assets/icon_cgyx_dls_s.png"),
          link: "/postdetail/4"
        },

        {
          imgbg1: require("@/assets/icon_cgyx_s.png"),
          imgbg2: require("@/assets/icon_cgyx_n.png"),
          title: "其他",
          img1: require("@/assets/icon_cgyx_sy_n.png"),
          img2: require("@/assets/icon_cgyx_sy_s.png"),
          link: "/search"
        }
      ],
      // navas: ["现货产品", "定制产品", "实验技术服务", "技术咨询", "积分好礼"], 
      navas: ["现货产品", "技术咨询", "积分好礼"],
      navasIndex: 0,
       selectedCategory: null,
      hoverTimer: null,
      leaveTimer: null,
      currentIndex: 0,
      categories: [],
      hotProductList:[],
      scoreProductList:[],
      slideList:[],
      category_id:0
    };
  },
  computed: {
    ...mapGetters(['base']),
    currentCategory() {
      return this.categories.find(cat => cat.id === this.selectedCategory);
    }
  },
  watch: {
    base: {
      handler(newVal) {
        // if(newVal.category&&newVal.category.length>0){
        //   this.categories = newVal.category.map(item => {
        //     return {
        //       id: item.id,
        //       name: item.title,
        //       brands: item.child.map(child => ({
        //         id: child.id,
        //         name: child.title,
        //         models: []
        //       }))
        //     }
        //   })
        //   this.selectedCategory = this.categories[0].id
        // }
   
      },
      immediate: true
    }
  },
  beforeMount() {
    this.selectedCategory = this.$route.params.id
    this.getCategory()
    this.getHotProduct(51)
    this.getRecommendGoods()
    // this.getIndex()
  },
  mounted() {},
  methods: {
    // getIndex(){
    //   this.$api.getIndex().then(res=>{
    //     console.log('获取首页数据成功',res);
    //     if(res.code == 1){
    //       this.slideList = res.data.slide_list
    //     }
    //   }).catch(err=>{
    //     console.log('获取首页数据失败',err);
    //   })
    // },
    goProduct(item,type){
      this.$router.push({path:'/productinfo/'+item.id+'?cateid='+item.category_id})
    },
    async getHotProduct(id){
      try {
        const res = await this.$api.getRecommendGoods()
        console.log('res.data',res)
        this.category_id = id
        if(res.code==1){
          this.hotProductList = res.data.slice(0,4)
         
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async getRecommendGoods(){
      try {
        const res = await this.$api.getScoreRecommendGoods()
        console.log('res.data',res)
        if(res.code==1){
          this.scoreProductList = res.data
         
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    getCategory(){
      this.$api.getCate().then(res => {
        if(res.code==1){
          this.categories = res.data.map(item => {
            return {
              id: item.id,
              name: item.title,
              brands: item.child.map(child => ({
                id: child.id,
                name: child.title,
                models: []
              }))
            }
          })
        }
      }).catch(err => {
        console.log(err);
      });
    },
    mouseoverClick(index) {
      this.currentIndex = index;
    },
    handleCategoryHover(category) {
      clearTimeout(this.leaveTimer);
      if (category.brands.length > 0) {
        this.hoverTimer = setTimeout(() => {
          this.selectedCategory = category.id;
        }, 150);
      }
    },
    handleCategoryLeave() {
      clearTimeout(this.hoverTimer);
      this.leaveTimer = setTimeout(() => {
        this.selectedCategory = null;
      }, 200);
    },
    keepMenuVisible() {
      clearTimeout(this.leaveTimer);
    },
    handleMenuLeave() {
      this.handleCategoryLeave();
    },
    selectModel(brand, model) {
      console.log("选中：", brand.name, model);
       this.$router.push({ path: "/productinfo" }, () => {}, () => {});
    },
    navasClick(index) {
      this.navasIndex = index;
      switch(index){
        case 0:
          this.getHotProduct(51)
          break
        // case 1:
        //   this.getHotProduct(52)
        //   break
        // case 2:
        //   this.getHotProduct(53)
        //   break
        case 1:
          // this.getConsultProduct()
          this.$router.push({path:'/consultationview'})
          break
        case 2:
          // this.getGiftProduct()
          document.getElementById('point').scrollIntoView({behavior:'smooth'})
          break
      }
    }
  }
};
</script> 

<style lang="less"  scoped>
.shop-view{
  padding-bottom:16px;
}
.top {
  width: 100%;
  height: 540px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 90px;
  position: relative;
  .top_carousel{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .cate-wrap{
    position: relative; 
    margin-left: 18%;
    margin-right: 18%;
    height: 540px;
    width: 68%;
    z-index: 99;
  }
}

.navs {
  height: 80px;
  background: #ffffff;
  line-height: 80px;
  padding-left: 18%;
  padding-right: 18%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.navs div {
  text-align: center;
  flex: 1;
}
.div_activity {
  cursor: pointer;
  background: rgba(60, 156, 143, 1);
  color: white;
  font-size: 18px;
  font-weight: 700;
}
.div_noma {
  cursor: pointer;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-weight: 400;
}
.point{
  display: relative;
  top: -100px;
}
.banner22s {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
.banner22s_span {
  margin-left: 18%;
  color: #3e3e3e;
  font-size: 44px;
  line-height: 64px;
  margin-bottom: 15px;
}

.carousel-container {
  margin-left: 18%;
  margin-right: 18%;
}

.carousel-track {
  height: 100%;
  width: 100%; /* 双倍宽度容纳重复图片 */
  display: flex; 
  flex-wrap: wrap;
  gap: 15px;
}

.carousel-item {
  width: calc(25% - 15px);
  height: 330px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.carousel-item img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}
.carousel-item span {
  height: 50px;
  width: 100%;
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  color: #333333;
}

.carousel-item2 {
  cursor: pointer;
  width: calc(25% - 15px);
  height: 264px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.carousel-item3 {
  cursor: pointer;
  width: calc(25% - 15px);
  height: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #ffffff;
  transition: all 0.3s ease;
  &:hover{
    box-shadow: 0px 0px 20px #aaaaaa;
  }
}
.carousel-item2_img {
  width: 100%;
  height: auto;
  object-fit: cover;
  background: rgba(60, 156, 143, 0.3);
}

.carousel-item2_img2 {
  width: 100%;
  height: auto;
  object-fit: cover; 
  aspect-ratio: 3/2;
}
.goods-title{
  width: 100%;
  font-size: 16px;
  line-height: 20px;
  height: 60px;
  color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
}
.goods-title-text{
  width: 100%;
  height: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-align: center;
}
.cgyx {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 18%;
  margin-right: 18%;
}
.cgyx_top {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.ccs_inner_data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
}
.text1 {
  color: #ffffff;
  font-size: 28px;
  line-height: 41px;
  margin-top: 10px;
}
.text2 {
  color: #3c9c8f;
  font-size: 28px;
  line-height: 41px;
  margin-top: 10px;
}
.text3 {
  color: #ffffff;
  font-size: 14px;
  line-height: 40px;
  width: 120px;
  height: 40px;
  margin-top: 10px;
  text-align: center;
  background: #e69f3e;
}
</style>
 


